import { jsx as _jsx } from "react/jsx-runtime";
export const SourgumTwentyYdDimensions2 = (props) => {
    const src = new URL('./dumpster-20.png', import.meta.url).toString();
    return _jsx("img", { ...props, src: src, alt: "Twenty Yard Dimensions" });
};
//# sourceMappingURL=twenty-yard-dimensions-sourgum2.js.map